// Interface
// *****************************************************
interface StatisticValueProps {
  name?: string,
  zeroColor?: string,
  mainColor?: string,
  value?: number | string,
}


/**
 * @description Statistic value component. It has a name and a value, and the value can be zero or
 * greater than zero, and the color will change accordingly.
 * * **name** - the name of the statistic value
 * * **zeroColor** - the color of the value if it's zero; default: 'text-ink-light'
 * * **mainColor** - the color of the value if it's greater than zero; default: 'text-ink'
 * * **value** - the value of the statistic
 *
 * @example
 * // display a statistic value with a name and a value
 * <StatisticValue name="Total" value={10} zeroColor={text-ink} activeColor={text-primary} />
 */
export const StatisticValue = (props: StatisticValueProps) => {
  // Destructure props
  const {
    name = '',
    zeroColor = 'text-ink-light',
    mainColor = 'text-ink',
    value = 0,
  } = props;

  // Value color
  const valueColor = value === 0 ? zeroColor : mainColor;

  // Render component
  return (
    <div className="flex flex-col">
      <div className="grow text-sm text-ink-medium">{name}</div>
      <div className={`-mb-0.5 text-xl font-bold ${valueColor}`}>{value}</div>
    </div>
  );
};
